var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import TextEnhancer from './TextEnhancer';

var I18nVizWrapper = function (_React$Component) {
  _inherits(I18nVizWrapper, _React$Component);

  function I18nVizWrapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, I18nVizWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = I18nVizWrapper.__proto__ || Object.getPrototypeOf(I18nVizWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isHovering: false,
      measure: {}
    }, _this.setHovering = function (isHovering) {
      _this.setState({ isHovering: isHovering });
    }, _this.handleRef = function (ref) {
      _this.outerRef = ref;
    }, _this.handleMouseEnter = function () {
      return _this.setHovering(true);
    }, _this.handleMouseLeave = function () {
      return _this.setHovering(false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(I18nVizWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var measure = this.outerRef.getBoundingClientRect();
      this.setState({ measure: measure });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          description = _props.description;
      var _state = this.state,
          isHovering = _state.isHovering,
          measure = _state.measure;


      return React.createElement(
        'span',
        {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          ref: this.handleRef
        },
        React.createElement(
          TextEnhancer,
          {
            id: id,
            description: description,
            isVisible: isHovering,
            measure: measure
          },
          this.props.children
        )
      );
    }
  }]);

  return I18nVizWrapper;
}(React.Component);

I18nVizWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string
};
export default I18nVizWrapper;


//////////////////
// WEBPACK FOOTER
// ../lib/components/I18nVizWrapper.js
// module id = 99
// module chunks = 0